<section [formGroup]="stepForm">
  <mbs-form-group>
    <mbs-radio
      formControlName="clusterBackup"
      name="clusterBackup"
      (change)="clusterBackupChangeHandler($event)"
      [id]="'cluster-backup-radio-1'"
      [label]="'wizards:clusterOffLabel' | i18next"
      [value]="false"></mbs-radio>
    <mbs-radio
      formControlName="clusterBackup"
      name="clusterBackup"
      (change)="clusterBackupChangeHandler($event)"
      [id]="'cluster-backup-radio-2'"
      [label]="'wizards:clusterOnLabel' | i18next"
      [descriptionOutside]="false"
      [value]="true">
      <ng-template radioDescription>
        <mbs-input
          class="d-block mb-2"
          formControlName="login"
          name="login"
          [boldLabel]="true"
          [id]="'cluster-login'"
          [label]="'wizards:select_host_login' | i18next"
          [showRequiredMark]="false"
          [validationWhitespace]="true"
          (change)="resetIsValidCredentials()"></mbs-input>
        <mbs-input-password
          formControlName="password"
          [boldLabel]="true"
          [disabledEye]="isEdit && value?.password === initialValue?.password"
          [id]="'cluster-password-input'"
          [label]="'wizards:select_host_password' | i18next"
          [placeholder]="'wizards:password_placeholder' | i18next"
          [showRequiredMark]="false"
          (focus)="passwordFocusHandler($event)"
          (blur)="passwordBlurHandler($event)"
          (input)="resetIsValidCredentials()"></mbs-input-password>
        <mbs-alert
          class="my-3"
          [class.opacity-50]="!stepForm?.get('clusterBackup')?.value"
          [type]="mbsPopupType.info"
          [icon]="true">
          {{ 'wizards:clusterInfoAlert' | i18next }}
        </mbs-alert>

        <!--TODO Implement later-->
        <!--<mbs-checkbox
          formControlName="remember"
          [descriptionOutside]="false"
          [label]="'wizards:clusterRememberLabel' | i18next"
          [id]="'cluster-remember-checkbox'">
          <ng-template checkboxDescription>
            <span [class.text-gray-500]="!stepForm?.get('clusterBackup')?.value">
              {{ 'wizards:clusterRememberDescription' | i18next }}
            </span>
          </ng-template>
        </mbs-checkbox>

        <mbs-checkbox
          formControlName="skipCredentials"
          [label]="'wizards:clusterSkipLabel' | i18next"
          [id]="'cluster-skip-checkbox'"></mbs-checkbox>-->
      </ng-template>
    </mbs-radio>
  </mbs-form-group>
</section>
